export const cleanInternalStack = (stack: string) => stack.replace(/\s+at .*aggregate-error\/index.js:\d+:\d+\)?/g, '');